import useStore from '../Store/market_greeks_data_store';



// === UTILITIES ===
function std(arr) {
  const mean = arr.reduce((a, b) => a + b, 0) / arr.length;
  return Math.sqrt(arr.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b, 0) / arr.length);
}

// === MAIN DATA MERGE FUNCTION ===
export function prepareMarketAIData() {
  const { spxData, vvixData, spxGexData } = useStore.getState();

  console.log('[STORE] vvixData sample:', vvixData.slice(0, 40));
  console.log('[STORE] spxData sample:', spxData.slice(0, 5));
  console.log('[STORE] spxGexData sample:', spxGexData.slice(0, 5));

  const merged = spxData.map((spx) => {
    const date = spx.date;
    const vvix = vvixData.find(d => d.date === date) || {};
    const gex = spxGexData.find(d => d.date === date) || {};

    return {
      date,
      'SPX open': parseFloat(spx.open),
      'SPX high': parseFloat(spx.high),
      'SPX low': parseFloat(spx.low),
      'SPX close': parseFloat(spx.close),
      'VVIX fast': parseFloat(vvix.vvix_avg_z_score),
      'VVIX slow': parseFloat(vvix.vvix_super_smooth_z_score),
      'SPX gex': parseFloat(gex.gex),
      'MS Gex': parseFloat(gex.z_5ma)
    };

  });

  return engineerFeatures(merged);
}

// === FEATURE ENGINEERING ===
function engineerFeatures(data) {
  return data.map((row, i, arr) => {
    const vvixFastSeries = arr.map(r => r['VVIX fast']);

    let vvixPressure = null;

    if (i >= 20) {
      const diffSlice = vvixFastSeries.slice(i - 5 + 1, i + 1) // last 5 diffs
        .map((val, idx) => val - vvixFastSeries[i - 5 + idx] ?? 0);
      const diffSum = diffSlice.reduce((a, b) => a + b, 0);

      const stdSlice = vvixFastSeries.slice(i - 20 + 1, i + 1).filter(v => typeof v === 'number');
      const stdDev = std(stdSlice);

      vvixPressure = diffSum / (stdDev + 1e-10);
    }

    const spxGexMomentum = (i >= 5)
      ? row['SPX gex'] - (arr[i - 5]?.['SPX gex'] ?? row['SPX gex'])
      : null;

    return {
      ...row,
      VVIX_pressure: vvixPressure,
      SPX_GEX_momentum_5: spxGexMomentum
    };
  }).filter(row =>
    row['SPX open'] != null &&
    row['VVIX fast'] != null &&
    row['SPX gex'] != null &&
    row['MS Gex'] != null
  );
}


